export const TOAST_DURATION = 1500
// export const API_URL = process.env.API_URL || 'http://10.5.0.2:4000/api/v1'
export const API_URL = process.env.API_URL || 'https://api.back-of-the-envelope.com/api/v1'

// export const STRIPE_PK = 'pk_test_mHaZtcBkqSGFmZZmJY3rlkrv'
export const STRIPE_PK = 'pk_live_4Dv5OOygwoiVIjVpl2ZgdBFX'
